var map = {
	"./DESIGN1.jpg": 185,
	"./DESIGN10.jpeg": 4138,
	"./DESIGN11.jpeg": 7825,
	"./DESIGN12.jpeg": 5552,
	"./DESIGN13.jpeg": 8775,
	"./DESIGN14.jpeg": 4414,
	"./DESIGN15.jpeg": 4677,
	"./DESIGN16.jpeg": 9172,
	"./DESIGN2.jpg": 1518,
	"./DESIGN3.jpg": 7355,
	"./DESIGN4.jpg": 3752,
	"./DESIGN5.jpg": 8581,
	"./DESIGN6.jpg": 4442,
	"./DESIGN7.jpg": 247,
	"./DESIGN8.jpg": 2772,
	"./DESIGN9.jpg": 6497
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 648;